import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/options-saas/app/(marketing)/gex-api/client.tsx");
